import React from 'react';

import { CommonStyles } from '../../common/react/CommonStyles';
import { DeprecatedReactMenu } from '../../common/react/components/Menu';
import { imgUrl } from '../../common/utilities/ImgUrl';

export class TypeaheadFilterButton extends React.Component<TypeaheadFilterButton.Props, any> {

  static displayName = 'TypeaheadFilterButton';

  static element = React.createFactory(TypeaheadFilterButton);

  public render() {

    const valueSpan = React.createElement('div', {
        style: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',

          height: CommonStyles.Sizes.LineHeight,

          paddingTop: CommonStyles.Sizes.TextBoxPadding,
          paddingLeft: CommonStyles.Sizes.TextBoxPadding
        }
      },
      this.props.buttonTitle);

    return React.createElement('div', {
        style: {
          height: CommonStyles.Sizes.RowHeight,
          backgroundColor: CommonStyles.Colors.White,
          boxSizing: 'border-box',
          borderWidth: CommonStyles.Sizes.TextBoxBorderSize,
          borderColor: CommonStyles.Colors.BorderColor,
          borderStyle: 'solid'
        }
      },
      React.createElement('div', {
        style: {
          float: 'right',
          width: CommonStyles.Sizes.NormalIconSize - CommonStyles.Sizes.TextBoxBorderSize,
          height: '100%',
          background: imgUrl('dropdown_arrow_normal.svg')+' center center no-repeat',
          borderLeftWidth: CommonStyles.Sizes.TextBoxBorderSize,
          borderLeftColor: CommonStyles.Colors.BorderColor,
          borderLeftStyle: 'solid'
        }
      }),
      valueSpan);
  }
}

export module TypeaheadFilterButton {

  export interface Props extends DeprecatedReactMenu.ButtonProps {
    buttonTitle: string;
  }

}
